import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SizePicture } from 'app/models2/commos/size-pircture';
import { UploadService } from 'app/services/upload.service';
import { LocalStorageService } from 'brainloper-ui';

@Component({
  selector: 'app-modal-files',
  templateUrl: './modal-files.component.html',
  styleUrls: ['./modal-files.component.scss'],
})
export class ModalFilesComponent implements OnInit, OnDestroy {
  public sizePicture: SizePicture;
  public imageSrc: string;
  public companyId = this.storage.get<number>('companyId');

  constructor(
    public dialogRef: MatDialogRef<ModalFilesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private uploadService: UploadService,
    private storage: LocalStorageService
  ) {
    this.dialogRef.addPanelClass('custom-modal-files');
  }

  ngOnInit(): void {
    this.sizePicture = {
      width: '100%',
      height: screen.width > 400 ? '340px' : '250px',
    };

    if (typeof this.data === 'string' && this.data.startsWith('http')) {
      this.imageSrc = this.data;
    } else {
      this.imageSrc = this.uploadService.getImagen(this.data, this.companyId);
    }
  }

  ngOnDestroy(): void {
    this.dialogRef.removePanelClass('custom-modal-files');
  }
}
